module.exports = __webpack_public_path__ + "static/Experience-the-Synergy-of-Dual-Therapies-Today-61d50903091afb24c728a578d403a809.webp";